import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useMemo} from "react";
import {TowersSportsApi} from "../../../../apis/towers-sports-api/towers-sports-api";

import './squadflixLiveStream.css';
import LiveAcestreamPlayer from "../liveAcestreamPlayer/liveAcestreamPlayer";
import {StremioStream} from "../../../../apis/towers-sports-api/types";

export const SquadflixLiveStream = () => {

    const {channelId, streamId} = useParams<{ channelId: string, streamId: string }>();
    const [channel, setChannel] = React.useState(null);
    const [streams, setStreams] = React.useState<StremioStream[]>([]);
    const [loading, setLoading] = React.useState(true);
    const id = channelId;
    const navigate = useNavigate();

    useEffect(() => {
        TowersSportsApi.getAcestreamChannelById(id).then((response) => {
            setChannel(response);
            TowersSportsApi.getAcestreamChannelStreams(id).then((streamsResponse) => {
                setStreams(streamsResponse.streams || []);
                setLoading(false);
            });
        }).catch(() => {
        }).finally(() => {
            setLoading(false);
        })
    }, [id]);

    const selectedStream = useMemo(() => {
        return streams.find(s => s.hash === streamId);
    }, [streams, streamId]);

    return <div className="squadflix-live-stream">
        <LiveAcestreamPlayer streamId={streamId} title={selectedStream?.description} onClose={() => {
            navigate('/squadflix/live/channel/' + channelId);
        }}/>
    </div>;
}
